import React, { useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  Card,
  CardContent,
  MenuItem,
  InputLabel,
  Select,
  CardActions,
  Button,
  CardHeader,
  FormControl,
} from "@material-ui/core";
import TextareaAutosize from "@mui/base/TextareaAutosize";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { TextField } from "formik-material-ui";
import Header from "../../ReUseAbleComp/Header.jsx";
import { Helmet } from "react-helmet";
import axios from "axios";

const useStyle = makeStyles((theme) => ({
  padding: {
    padding: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(1),
  },
}));

let initialValues = {
  firstName: "",
  PhoneNumber: "",
  Gender: "",
  District: "",
  Address: "",
  ContactFor: "",
  title: "",
  Query: "",
};

const Gender = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Rather Not Say", value: "Rather Not Say" },
];
const District = [
  { label: "Peshawar", value: "Peshawar" },
  { label: "Mardan", value: "Mardan" },
  { label: "Khyber", value: "Khyber" },
];
const ContactFor = [
  { label: "Complaint", value: "Complaint" },
  { label: "Suggestion", value: "Suggestion" },
  { label: "FeedBack", value: "FeedBack" },
  { label: "Other", value: "Other" },
];

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

let validationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("Required")
    .min(3, "Username must be longer then 3 characters")
    .max(25, "Please be specific with yourname (Try a short name)"),
  PhoneNumber: Yup.string()
    .required("Required")
    .matches(phoneRegExp, "Phone number is not valid")
    .min(10, "phone number must not be less then 13 charachter")
    .max(13, "phone number must not be more then 13 charachter"),
  title: Yup.string().required("Required"),

  Address: Yup.string()
    .required("Required")
    .min(3, "too short")
    .max(100, "to long"),
  Query: Yup.string()
    .required("Required")
    .min(3, "to short")
    .max(100, "to long"),
});

const UserForm = () => {
  const [district, setdistrict] = useState("");

  useEffect(async () => {
    const res = await axios.get(
      "https://audiopedia.crispato.com/api/provinces.php"
    );
    console.log(res);
  }, []);

  let history = useHistory();
  const classes = useStyle();

  const onSubmit = (values) => {
    // const data = {
    //   ...values,
    //   username: firstname,
    // };
    // console.log(data);
    console.log(values);
  };
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const customFunction = () => {
    console.log("daskj,n");
  };
  const handleDistrictChange = (e) => {
    setdistrict(e.target.value);
  };
  console.log(district);
  return (
    <>
      <Helmet>
        <title>Feedback</title>
      </Helmet>

      <Header
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
      <br />
      <br />
      <br />
      <br />
      <br />
      <ToastContainer autoClose={4000} />
      <Grid
        container
        spacing={1}
        justify="center"
        style={{ marginTop: "20px" }}
      >
        <Grid item md={10}>
          <Card className={classes.padding}>
            <CardHeader title="Feedback Form"></CardHeader>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ dirty, isValid, values, handleChange, handleBlur }) => {
                return (
                  <Form>
                    <CardContent>
                      <Grid item container spacing={1} justify="center">
                        <Grid item xs={12} sm={6} md={6}>
                          <Field
                            label="Full Name"
                            variant="outlined"
                            fullWidth
                            name="firstName"
                            value={values.firstName}
                            component={TextField}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                          <Field
                            label="Phone Number"
                            variant="outlined"
                            fullWidth
                            name="PhoneNumber"
                            value={values.PhoneNumber}
                            component={TextField}
                            type="number"
                            min={9}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="demo-simple-select-outlined-label">
                              Gender
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              label="Gender"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.gender}
                              name="Gender"
                            >
                              <MenuItem>None</MenuItem>
                              {Gender.map((item) => (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="demo-simple-select-outlined-label">
                              District
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              label="District"
                              // onChange={handleChange}
                              // onBlur={handleBlur}
                              // value={values.District}
                              value={district}
                              onChange={(e) => setdistrict(e.target.value)}
                              name="District"
                            >
                              {/* <MenuItem>None</MenuItem> */}
                              {District.map((item) => (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <Field
                            label="Address"
                            variant="outlined"
                            fullWidth
                            name="Address"
                            value={values.Address}
                            component={TextField}
                            type="textarea"
                            min={9}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="demo-simple-select-outlined-label">
                              ContactFor
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              label="ContactFor"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.ContactFor}
                              name="ContactFor"
                            >
                              <MenuItem>None</MenuItem>
                              {ContactFor.map((item) => (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12}>
                          <Field
                            label="Title"
                            variant="outlined"
                            fullWidth
                            name="title"
                            value={values.title}
                            component={TextField}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <Field
                            label="Query"
                            variant="outlined"
                            fullWidth
                            name="Query"
                            value={values.Query}
                            component={TextField}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                    <CardActions>
                      <Button
                        disabled={!dirty || !isValid}
                        variant="contained"
                        color="primary"
                        type="Submit"
                        className={classes.button}
                        // onClick={onSubmit()}
                      >
                        Submit
                      </Button>
                    </CardActions>
                  </Form>
                );
              }}
            </Formik>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default UserForm;

// import React, { useState, useRef } from "react";
// import {
//   ValidatorForm,
//   TextValidator,
// } from "react-material-ui-form-validator";
// import {
//   Grid,
//   makeStyles,
//   Card,
//   CardContent,
//   MenuItem,
//   InputLabel,
//   Select,
//   CardActions,
//   Button,
//   CardHeader,
//   FormControl,
// } from "@material-ui/core";
// const FeedBackForm = () => {
//   const FormData = useRef("form");

//   const [username, setUsername] = useState("");
//   const [submitted, setSubmitted] = useState(false);

//   const handleSubmit = () => {
//     console.log("submitted", username);
//   };

//   return (
//     <>
//       <ValidatorForm ref={FormData} onSubmit={handleSubmit}>
//         <h2>Simple form</h2>
//         <TextValidator
//           label="username"
//           onChange={(e) => setUsername(e.target.value)}
//           name="username"
//           value={username}
//           validators={["required", "isString"]}
//           errorMessages={[
//             "this field is required",
//             "email is not valid",
//           ]}
//         />
//         <br />
//         {/* <TextValidator
//           label="Password"
//           onChange={handleChange}
//           name="password"
//           value={formData.password}
//           validators={["required"]}
//           errorMessages={["this field is required"]}
//         />
//         <br /> */}
//         <Button
//           color="primary"
//           variant="contained"
//           type="submit"
//           disabled={submitted}
//         >
//           {(submitted && "Your form is submitted!") ||
//             (!submitted && "Submit")}
//         </Button>
//       </ValidatorForm>
//     </>
//   );
// };

// export default FeedBackForm;
